<script setup lang="ts">
import Page from '@/components/Page.vue';
</script>

<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <Page :class="$style.root" :title="$t`Impressum`">
    <div class="hh">
      <h2>{{ $t`Impressum` }}</h2>
    </div>

    <div class="clearfix ms-c">
      <p>
        Herausgeber und inhaltlich Verantwortlicher gemäß §6 TDG, §10 MDStV,
        V.i.S.d.P:
      </p>
      <p class="float-start w-s me-3">
        <b>Castalian Spring GmbH</b><br />
        Maksim Kulsha<br />
        Schulzendorfer Str 24<br />
        13347 Berlin<br />
        tel: +49 15 222 768 409<br />
        e-mail: info@castalianspring.de<br />
      </p>
      <p class="float-start w-s">
        Geschäftsführer: <b>Maksim Kulsha</b><br />
        <br />
        Registergericht:<br />
        Amtsgericht Berlin (Charlottenburg)<br />
        HRB 178826 B<br />
        Umsatzsteuer ID-Nr.: DE 308490959<br />
      </p>
    </div>
    <h4>Erklärung zur Linksetzung</h4>
    <p>
      Der inhaltlich Verantwortliche erklärt ausdrücklich, dass zum Zeitpunkt
      einer Linksetzung die entsprechenden verlinkten Seiten frei von illegalen
      Inhalten waren. Der Herausgeber hat keinerlei Einfluss auf die aktuelle
      und zukünftige Gestaltung und auf die Inhalte der verknüpften Seiten.
      Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller
      gelinkten Seiten, die nach der Linksetzung verändert wurden.
    </p>
    <h4>Inhalte</h4>
    <p>
      Die Inhalte der Internetseiten werden sorgfältig geprüft und nach bestem
      Wissen erstellt. Jedoch kann keinerlei Gewähr für die Korrektheit,
      Vollständigkeit, Aktualität oder Qualität der bereitgestellten
      Informationen übernommen werden. Haftungsansprüche gegen den inhaltlich
      Verantwortlichen, welche sich auf Schäden materieller oder ideeller Art
      beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen
      Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger
      Informationen verursacht wurden sind grundsätzlich ausgeschlossen, sofern
      auf Seiten des inhaltlich Verantwortlichen kein nachweislich vorsätzliches
      oder grob fahrlässiges Verschulden vorliegt. Namentlich gekennzeichnete
      Beiträge spiegeln nicht unbedingt die Meinung des Herausgebers wider.
    </p>
    <h4>Urheberrechtliche Hinweise</h4>
    <p>
      Der inhaltlich Verantwortliche ist bestrebt, in allen Publikationen die
      Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und
      Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente,
      Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken,
      Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des
      Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und
      Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils
      gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen
      eingetragenen Eigentümer. Das Copyright für veröffentlichte, selbst
      erstellte Objekte bleibt allein beim inhaltlich Verantwortlichen oder dem
      jeweiligen Eigentümer. Eine Vervielfältigung oder Verwendung der Grafiken,
      Tondokumente, Videosequenzen und Texte in anderen elektronischen oder
      gedruckten Publikationen ist ohne ausdrückliche Zustimmung nicht
      gestattet.
    </p>
    <h4>Datenschutz</h4>
    <p>
      Die Verarbeitung Ihrer Daten erfolgt nach den einschlägigen gesetzlichen
      Regelungen. Wir weisen darauf hin, dass die Datenübertragung über das
      Internet derzeit im Wesentlichen ungesichert erfolgt. Es ist nicht
      ausgeschlossen, dass übermittelte Daten von Unbefugten zur Kenntnis
      genommen und eventuell sogar verfälscht werden. An uns übermittelte Daten
      (z.B. Name, Vorname, Firma, Strasse, Postleitzahl, Ort, Telefon, E-Mail)
      werden ausschließlich zum jeweils angegeben Zweck genutzt und für die
      Dauer der Bearbeitung in elektronischer Form gespeichert. Eine Weitergabe
      an Dritte erfolgt nicht. Mit der Nutzung der entsprechenden Anwendungen
      willigen Sie in die genannte Verarbeitung Ihrer Daten ein. Sie können
      diese Einwilligung schriftlich oder per E-Mail gegenüber dem inhaltlich
      Verantwortlichen jederzeit mit Wirkung für die Zukunft widerrufen. Ferner
      haben Sie das Recht, auf Antrag unentgeltlich Auskunft über die über Sie
      gespeicherten personenbezogenen Daten zu erhalten. Zusätzlich haben Sie
      ein Recht auf Berichtigung, Sperrung und Löschung.
    </p>
    <p>
      Die Europäische Kommission stellt eine Plattform zur
      Online-Streitbeilegung (OS) bereit, die Sie hier finden:
      http://ec.europa.eu/consumers/odr/. Verbrauchern haben die Möglichkeit,
      diese Plattform für die Beilegung ihrer Streitigkeiten zu nutzen. Unsere
      E-Mail-Adresse: info@castalianspring.de. Zur Teilnahme an einem
      Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir
      nicht verpflichtet und nicht bereit..
    </p>
    <p>©2026 Castalian Spring GmbH</p>
  </Page>
</template>

<style lang="scss" module>
.root {
  /* Not empty */
}
</style>
